/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Menueditorfullheading3Inputs */

const en_menueditorfullheading3 = /** @type {(inputs: Menueditorfullheading3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit the menu`)
};

const de_menueditorfullheading3 = /** @type {(inputs: Menueditorfullheading3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Speisekarte bearbeiten`)
};

/**
* | output |
* | --- |
* | "Edit the menu" |
*
* @param {Menueditorfullheading3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const menueditorfullheading3 = /** @type {((inputs?: Menueditorfullheading3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Menueditorfullheading3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_menueditorfullheading3(inputs)
	return de_menueditorfullheading3(inputs)
});
export { menueditorfullheading3 as "menuEditorFullHeading" }